import {
  TabsList,
  TabsTrigger,
  type TabsListProps,
  type TabsTriggerProps,
} from '@monksflow/monks-ui';

/**
 * Tessra's `Tabs` draws one treatment, the raised pill on a light track. The other tab shape
 * in this product is the underlined row the project section nav uses, and the design system
 * has no variant for it, so it is stated once here rather than in every screen that asks for
 * it. Compose these with Tessra's own `Tabs` and `TabsContent`.
 */
export const UnderlineTabsList = ({ className = '', ...props }: TabsListProps) => (
  <TabsList
    className={`w-full justify-start gap-xs rounded-none border-b border-border bg-transparent p-0 group-data-[orientation=horizontal]/tabs:h-auto ${className}`}
    {...props}
  />
);

/**
 * The pill Tessra draws behind the active tab is restyled into the bar rather than hidden and
 * replaced by a border: the pill carries the shared-element projection that slides it between
 * tabs, and a border would jump instead.
 */
export const UnderlineTabsTrigger = ({ className = '', ...props }: TabsTriggerProps) => (
  <TabsTrigger
    className={`type-label-md gap-xs rounded-none px-sm py-sm font-normal data-[state=active]:font-medium [&_[data-slot=tabs-indicator]]:-bottom-px [&_[data-slot=tabs-indicator]]:top-auto [&_[data-slot=tabs-indicator]]:h-0.5 [&_[data-slot=tabs-indicator]]:rounded-none [&_[data-slot=tabs-indicator]]:bg-foreground [&_[data-slot=tabs-indicator]]:shadow-none ${className}`}
    {...props}
  />
);
